export { default } from "./SummaryRow";
